import { render, staticRenderFns } from "./CredorInfoPlano.vue?vue&type=template&id=2b2d78a6&"
import script from "./CredorInfoPlano.vue?vue&type=script&lang=js&"
export * from "./CredorInfoPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports